import React from 'react';
import { useSelector } from 'react-redux';
import DTHandleCheggBookIssuesNode from '../Nodes/DTHandleCheggBookIssuesNode/DTHandleCheggBookIssuesNode';
import { getShowConfirmationPage } from '../../../selectors/tools';

const CheggHandleBookIssuesThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTHandleCheggBookIssuesNode showConfirmation={showConfirmationPage} message={'The book issue has been filed.'} />
  );
};

export default CheggHandleBookIssuesThenSendMacro;
